import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button } from '@mui/material';
import { CheckOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CustomDialog from '@ui/components/common/Dialog';
import AddNewTask from '@ui/pages/Tasks/AddNewTask';
const CreateTaskDialog = ({ open, onClose, ActivityId, PersonId }) => {
    const { t } = useTranslation();
    const formRef = useRef(null);
    const handleSubmit = () => {
        if (formRef.current) {
            formRef.current.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        // Note: onClose() is now handled by the AddNewTask component after successful form submission
    };
    return (_jsx(CustomDialog, { open: open, onClose: onClose, title: t('tasks.newTask'), maxWidth: 'md', actions: _jsxs(_Fragment, { children: [_jsx(Button, { fullWidth: true, onClick: onClose, variant: 'outlined', color: 'inherit', size: 'large', children: t('actions.cancel') }), _jsx(Button, { fullWidth: true, variant: 'contained', color: 'inherit', size: 'large', startIcon: _jsx(CheckOutlined, {}), onClick: handleSubmit, children: t('actions.createTask') })] }), children: _jsx(AddNewTask, { isActivityTask: true, isCreateAllowed: true, dialog: true, ActivityId: ActivityId, PersonId: PersonId, formRef: formRef, onClose: onClose }) }));
};
export default CreateTaskDialog;
